import { render, staticRenderFns } from "./qr_signin_new_template.vue?vue&type=template&id=d97a921a&scoped=true&"
import script from "./qr_signin_new_template.vue?vue&type=script&lang=js&"
export * from "./qr_signin_new_template.vue?vue&type=script&lang=js&"
import style0 from "./qr_signin_new_template.vue?vue&type=style&index=0&id=d97a921a&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97a921a",
  null
  
)

export default component.exports